var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"协议信息","visible":_vm.isShow,"width":"1200px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.isShow=$event},"close":_vm.closeDetail}},[_c('ProtocolDetail',{attrs:{"protocolId":_vm.protocolId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20b46f17","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/child/view/ProtocolDetailDialog.vue
// module id = null
// module chunks = 